<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ProductListInfinite" });
import * as API from "../../services/api.js";
export let parameters = void 0;
export let isPreview = false;
const DEFAULT_BATCH_SIZE = 100;
const CAMPAIGN_PRODUCT_LIMIT = 20;
let offset = 0;
let limit = DEFAULT_BATCH_SIZE;
let products = [];
let isLoading = false;
let isEndOfList = false;
let prevParams = JSON.stringify(parameters);
const fetchProducts = (params) => {
    isLoading = true;
    void API.filterProducts(params).then((result) => {
        if (Array.isArray(result)) {
            const NEW_BATCH = result;
            products = [...products, ...NEW_BATCH];
            isLoading = false;
            if (NEW_BATCH.length === 0 || NEW_BATCH.length < limit) {
                isEndOfList = true;
            }
        }
    });
};
const loadMoreProducts = () => {
    offset += DEFAULT_BATCH_SIZE;
    fetchProducts({ ...parameters, limit, offset });
};
const reset = () => {
    offset = 0;
    products = [];
    isEndOfList = false;
};
const onParametersChange = (params) => {
    if (JSON.stringify(params) === prevParams) {
        return;
    }
    prevParams = JSON.stringify(params);
    reset();
    fetchProducts({ ...params, limit, offset });
};
$: onParametersChange(parameters);
const onPreviewChange = (isPreview2) => {
    limit = isPreview2 ? CAMPAIGN_PRODUCT_LIMIT : DEFAULT_BATCH_SIZE;
    reset();
    fetchProducts({ ...parameters, limit, offset });
};
$: onPreviewChange(isPreview);
let sentinelElement;
const observeIntersection = (node) => {
    const OBSERVER = new IntersectionObserver((entries) => {
        if (entries.length > 0 && entries[0].isIntersecting) {
            if (!isLoading && !isEndOfList && !isPreview) {
                loadMoreProducts();
            }
        }
    }, { threshold: 0.1 });
    OBSERVER.observe(node);
    return {
        destroy() {
            OBSERVER.disconnect();
        }
    };
};
</script>

{#if products.length > 0}
    <div class = 's8-products-list'>
        <slot { products } { isLoading } { isEndOfList }>
            <pre>{ JSON.stringify(products, null, 4) }</pre>
        </slot>

        <!-- Sentinel element always positioned one quarter above the bottom of the page -->
        <div
            bind:this = { sentinelElement }
            use:observeIntersection
            class = 's8-scroll-sentinel'
        ></div>
    </div>
{:else}
    <slot name = 'empty' />
{/if}

<style>
    .s8-products-list {
        position: relative;
    }

    .s8-scroll-sentinel {
        position: absolute;
        top: 75%;
        height: 1px;
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
    }</style>